const createCustomError = (message: string) => ({
    e: { message },
});

export { createCustomError };
